import React, { useRef, useState, useEffect } from 'react'
import userApi from 'src/utils/axios';;
import { Formik } from "formik";
import * as yup from 'yup';
import ConfigData from './../../../config/constant.json'
import {
    CSpinner, CCard, CCardBody,
    CCardGroup, CCol, CContainer, CCardTitle,
    CForm, CFormInput, CInputGroup, CRow, CFormCheck, CFormTextarea, CToaster, CFormSelect, CToast, CToastHeader, CToastClose, CToastBody
} from '@coreui/react'
import Multiselect from 'multiselect-react-dropdown';
import LoadingScreen from 'src/views/shared/Loading';

const Notification = () => {
    let [error, setError] = React.useState(false)
    const [loader,setLoader] = React.useState(false);
    const [toast, addToast] = React.useState(0)
    const [isLoading, setIsLoading] = React.useState(false)
    const [users, setUsers] = React.useState(false)
    const [updatedUsersList, setUpdatedUsersList] = React.useState([]);
    const [selectUsersError,setSelectUsersError] = React.useState(false);
    const toaster = useRef()

    const notificationSchema = yup.object({
        title: yup.string().required('Notification title is required').min(3),
        body: yup.string().required('Notification Body is Required').min(5),
    });


    React.useEffect(async () => {
        setLoader(true)
        let response = await userApi.get(`${ConfigData.SERVER_URL}/admin/user/getusers`)
        setUsers(response.data.data)
        setLoader(false)
    }, [])

    let handleAddNotification = async (values) => {
        try {
            setIsLoading(true);
            if(updatedUsersList.length>0){
            // let response = await axios.post(`${ConfigData.SERVER_URL}/admin/notification/singleuser`, { ...values })

            let response = await userApi.post(`${ConfigData.SERVER_URL}/admin/notification/MultipleUser`, { ...values,users:updatedUsersList })
            if (response.data.status == false) {
                setIsLoading(false)
                throw Error(response.data.message);
            } else if (response.data.status == true) {
                setIsLoading(false)
                addToast(exampleToast);
                setUpdatedUsersList([]);
            }
        }else{
            setSelectUsersError(true)
            setIsLoading(false)
        }
        } catch (e) {
            setError(e)
            setIsLoading(false)
            console.log(e)
        }
    }
    const exampleToast = (
        <CToast title="CoreUI for React.js" >
            <CToastHeader close="true">
                <svg
                    className="rounded me-2"
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                    role="img"
                >
                    <rect width="100%" height="100%" fill="#007aff"></rect>
                </svg>
                <strong className="me-auto">Notification</strong>
                <small><CToastClose className="me-2 m-auto" /></small>
            </CToastHeader>
            <CToastBody>Notification sent to the recipient</CToastBody>
        </CToast>
    )


    return (
        <>
            <div style={{ margin: 20 }}>
                <CRow>
                    <CCol sm={12}>
                        <CCard style={{ background: "#34962d" }}>
                            <CCardBody>
                                <CRow>
                                    <CCol sm={4}> <CCardTitle style={{ color: "white" }}>Notifications </CCardTitle></CCol>
                                    <CCol sm={6}></CCol>
                                    <CCol sm={2}></CCol>
                                </CRow>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </div>
            {loader && <LoadingScreen></LoadingScreen>}
            {!loader &&
                users &&
                <CContainer style={{ width: '100%' }}>
                    <CRow className="justify-content-center">
                        <CCol md={10}>
                            <CCardGroup>
                                <CCard className="p-4">
                                    <CCardBody>
                                        <Formik
                                            initialValues={{ title: '', body: ''}}
                                            validationSchema={notificationSchema}
                                            onSubmit={(values, actions) => {
                                                handleAddNotification(values);
                                                actions.resetForm();
                                            }}
                                        >
                                            {(formikProps) => (
                                                <CForm>
                                                    <h1>Add Notification</h1>
                                                    <p className="text-medium-emphasis">Fill Form for Push Notification</p>

                                                    <CInputGroup className="mb-3">
                                                        <legend>Title</legend>
                                                        <CFormInput
                                                            placeholder="Notification Title"
                                                            autoComplete="title"
                                                            onChange={formikProps.handleChange('title')}
                                                            value={formikProps.values.title}
                                                            onBlur={formikProps.handleBlur('title')}
                                                        />
                                                    </CInputGroup>
                                                    <p style={{ color: 'red' }}>{formikProps.touched.title && formikProps.errors.title}</p>

                                                    <CInputGroup className="mb-3">
                                                        <legend>Body</legend>

                                                        <CFormInput
                                                            placeholder="Notification Body"
                                                            autoComplete="body"
                                                            onChange={formikProps.handleChange('body')}
                                                            value={formikProps.values.body}
                                                            onBlur={formikProps.handleBlur('body')}
                                                        />
                                                    </CInputGroup>
                                                    <p style={{ color: 'red' }}>{formikProps.touched.body && formikProps.errors.body}</p>

                                                    <div className="mb-3">
                                                        <legend>Send Notifications to</legend>
                                                        <Multiselect
                                                            style={{display:'flex'}}
                                                            displayValue="user"
                                                            onRemove={(event) => { setUpdatedUsersList(event) }}
                                                            onSelect={(event) => { setUpdatedUsersList(event),setSelectUsersError(false) }}
                                                            onSearch={function noRefCheck() { }}
                                                            options={users}
                                                            selectedValues={updatedUsersList}
                                                            showCheckbox
                                                        />
                                                        {selectUsersError && <p style={{ color: 'red' }}>Please select atleast one</p>}
                                                    </div>

                                                    <CRow>

                                                        <CCol xs={5}> </CCol>
                                                        {!isLoading && <CCol xs={7}> <button onClick={formikProps.handleSubmit} type="submit" className="btn btn-outline-primary">Submit</button> </CCol>}
                                                        {isLoading && <CCol xs={7}> <button disabled onClick={formikProps.handleSubmit} type="submit" className="btn btn-primary"><CSpinner component="span" size="sm" aria-hidden="true" />&nbsp;&nbsp;Submit</button> </CCol>}
                                                        <CToaster ref={toaster} push={toast} placement="top-end" />
                                                    </CRow>
                                                </CForm>
                                            )}
                                        </Formik>
                                        {error && <p style={{ color: 'red' }}>{error.message}</p>}
                                    </CCardBody>
                                </CCard>
                            </CCardGroup>
                        </CCol>
                    </CRow>


                </CContainer>
            }
        </>

    );
}

export default Notification;